import React, {Component} from 'react'
import Radium from 'radium'
import Link from "gatsby-link";
import SingleFormLayout from '../components/single-form-layout'
import Navbar from '../components/navbar'
import MobileContent from '../components/mobile-content'
import {FORM_STYLES} from '../components/assets/forms-shared'
import Palette from '../components/assets/palette'
import Color from 'color'
import Helmet from 'react-helmet'
import { HaikuMiniIconSVG, FacebookSVG, TwitterSVG, SlackSVG, HaikuIconGradioSVG } from '../components/assets/icons'
import MobileDetect from 'mobile-detect'

const windowWidth = (typeof window !== 'undefined') && window.innerWidth
const md = (typeof window !== 'undefined')
  ? new MobileDetect(window.navigator.userAgent)
  : {mobile: () => { return false }}
const isMobile = md.mobile()

import '../../src/layouts/main.css'

const STYLES = {
  blogHeaderWrap: {
    backgroundColor: Palette.COAL,
    position: 'relative',
    paddingTop: 90,
    paddingBottom: 30,
    color: Palette.SUNSTONE,
    textAlign: 'center',
    '@media screen and (max-width: 1115px)': {
      marginTop: 0
    },
  },
  flexContentWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 50,
    marginBottom: 50,
    '@media screen and (max-width: 1115px)': {
      marginTop: 0
    },
  },
  postsContentWrap: {
    width: '100%',
    maxWidth: 1000,
    height: '100%',
    paddingLeft: 20,
    paddingRight: 20,
    '@media screen and (max-width: 1115px)': {
      width: '90%',
      paddingLeft: 10,
      paddingRight: 10
    },
  },
  subtitle: {
    color: Palette.ROCK,
    fontSize: 15,
    marginTop: 5,
    fontWeight: 300,
    lineHeight: '22px',
  },
  flexGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'flex-start',
    flexWrap: 'wrap',
    '@media screen and (max-width: 1115px)': {
      display: 'block'
    }
  },
  flexGridImage: {
    position: 'relative',
    float: 'left',
    width: '34%',
    height: '100%'
  },
  flexGridContent: {
    padding: '0px 40px 12px 40px',
    position: 'relative',
    float: 'left',
    width: '66%'
  },
  h2: {
    color: Palette.SUNSTONE,
    minHeight: '2em',
    fontSize: 21,
    letterSpacing: .5,
    lineHeight: '27px',
    wordWrap: 'break-word',
    fontFamily: 'brandon-grotesque',
    textTransform: 'uppercase',
    paddingTop: 15,
    margin: '12px 0 12px'
  },
  subtitle: {
    color: '#d7e1e2',
    fontSize: 15,
    marginTop: 10,
    fontWeight: 300,
    lineHeight: '22px',
  },
  title: {
    color: 'white'
  },
  date: {
    marginTop: -2,
    marginBottom: 0,
    fontSize: 12,
    color: Color(Palette.DARKER_ROCK).darken(.2)
  },
  hideOnMobile: {
    '@media screen and (max-width: 700px)': {
      display: 'none'
    }
  },
  tag: {
    fontSize: 12,
    background: Palette.LIGHTEST_PINK,
    color: Palette.SUNSTONE,
    borderRadius: 4,
    padding: 3,
    display: 'inline-block',
    marginTop: 8
  },
  ...FORM_STYLES
}

export default function Index({ data }) {
  const { edges: posts } = data.allMarkdownRemark;
  return (
    <div>

      <Helmet>
        <title>Blog | Haiku</title>
        <meta name="description" content="Where Designing is building. Thoughts on interaction design, animation and code." />
        <meta property="og:title" content="Blog | Haiku" />
        <meta property="og:description" content="Where Designing is building. Thoughts on interaction design, animation and code." />
      </Helmet>

      <Navbar location="blog"/>

      <div style={{
        margin: '0 auto',
      }}>

        <div style={STYLES.blogHeaderWrap}>
          <Link style={STYLES.title} to="/blog/">
            <HaikuIconGradioSVG width={80} height={80} />
            <h1 style={{marginTop: 20}}>Haiku Blog</h1>
            <p style={STYLES.subtitle}>Articles, videos and resources by the Haiku team.</p>
          </Link>
        </div>

        <div style={STYLES.flexContentWrap}>
          <div style={STYLES.postsContentWrap}>
            <div style={STYLES.flexGrid}>
              {posts
                .filter(post => post.node.frontmatter.title.length > 0)
                .map(({ node: post }, index) => {
                  return (
                    <Link to={post.frontmatter.path} tabIndex={index + 10} className="flexGridBlog" key={post.id}>
                      <div style={STYLES.flexGridImage}>
                        <img className="blogFeatureImage" src={post.frontmatter.coverImage.publicURL} alt={post.frontmatter.title}/>
                      </div>
                      <div style={STYLES.flexGridContent}>
                        <h2 style={STYLES.h2}>{post.frontmatter.title}</h2>
                        <h4 style={STYLES.date}>{post.frontmatter.date}</h4>
                        {post.frontmatter.tags && post.frontmatter.tags.map((tag) => <span style={STYLES.tag}>{tag}</span>)}
                        <p style={STYLES.subtitle}>{post.excerpt}</p>
                      </div>
                    </Link>
                  );
                })}
            </div>

          </div>
        </div>
      </div>

    <MobileContent />

  </div>
  );
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 180)
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
            coverImage {
              publicURL
            }
            tags
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/blog.js